import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FiCompass,
  FiAward,
  FiStar,
  FiClock,
  FiTrendingUp,
  FiEye,
  FiThumbsUp,
  FiSearch,
} from "react-icons/fi";
import "./lexacquiretopnav.css";

export default function LexacquireTopnav() {
  const navigate = useNavigate();
  const location = useLocation();

  // ─── Tabs definition & state ───
  const tabs = [
    { key: "Landscape",   icon: <FiCompass />,   path: "/lexacquire/landscape" },
    { key: "Leaderboard", icon: <FiAward />,     path: "/lexacquire/leaderboard" },
    { key: "Featured",    icon: <FiStar />,      path: "/lexacquire/featured" },
    { key: "Newest",      icon: <FiClock />,     path: "/lexacquire/newest" },
    { key: "Trending",    icon: <FiTrendingUp />,path: "/lexacquire/trending" },
    { key: "Most Viewed", icon: <FiEye />,       path: "/lexacquire/most-viewed" },
    { key: "Most Voted",  icon: <FiThumbsUp />,  path: "/lexacquire/most-voted" },
  ];

  // Determine active tab by comparing location.pathname
  const [activeTab, setActiveTab] = useState(() => {
    const current = location.pathname.toLowerCase();
    const match = tabs.find((t) => current.startsWith(t.path.toLowerCase()));
    return match ? match.key : "Landscape";
  });

  // When the URL changes (e.g. user clicks Back/Forward), update activeTab
  useEffect(() => {
    const current = location.pathname.toLowerCase();
    const match = tabs.find((t) => current.startsWith(t.path.toLowerCase()));
    setActiveTab(match ? match.key : "Landscape");
  }, [location.pathname]);

  return (
    <nav className="lexacq-topbar">
      {/* Left: Tabs */}
      <div className="lexacq-tabbar">
        {tabs.map(({ key, icon, path }) => {
          const isActive = activeTab === key;
          return (
            <button
              key={key}
              className={`tab-item ${isActive ? "active" : ""}`}
              onClick={() => {
                setActiveTab(key);
                navigate(path);
              }}
            >
              <span className="tab-icon">{icon}</span>
              <span className="tab-label">{key}</span>
            </button>
          );
        })}
      </div>

      {/* Right: Search + Buttons */}
      <div className="lexacq-header-inline">
        <div className="lexacq-search-wrapper">
      
          <input
            type="text"
            className="lexacq-search-input"
            placeholder="Search agents…"
            
          />
        </div>

        <button
          className="lexacq-btn-request"
          onClick={() => navigate("/lexacquire/request")}
        >
          Request
        </button>
        <button
          className="lexacq-btn-submit"
          onClick={() => navigate("/lexacquire/submit")}
        >
          Submit
        </button>
      </div>
    </nav>
  );
}
